import { render } from "./NotFound.vue?vue&type=template&id=0c76f8db&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=0c76f8db&scoped=true&lang=css"

import exportComponent from "/var/www/documentation.probabilityworks.cloud/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c76f8db"]])

export default __exports__